export default __webpack_public_path__ + "static/media/visa.a1b49faf.svg";